import React from "react";
import { Dispatcher } from "../../flux";
import styled from "styled-components";

const StyledP = styled.p`
  line-height: 2rem;
`;

const enableEnhancedFormatting = () => {
  const isEnabled = Fraction.Helpers.isLabEnabled("enhanced-formatting");
  Dispatcher.emit(
    Dispatcher.SET_ENHANCED_FORMATTING,
    isEnabled,
    "enhanced-formatting"
  );
  if (isEnabled) {
    Fraction.Helpers.showModal(
      {
        title: i18n.t("enhanced-formatting.enabled-modal.title"),
        content: (
          <div>
            <StyledP>
              {window.toHTML(
                i18n.t("enhanced-formatting.enabled-modal.instructions", {
                  imgMenu: `<img src="/img/ef-aa.png" style="height: 24px;vertical-align: bottom;" alt="${i18n.t(
                    "enhanced-formatting.enabled-modal.view-options-button"
                  )}" />`
                })
              )}
            </StyledP>
            <StyledP>
              {window.toHTML(
                i18n.t("enhanced-formatting.enabled-modal.labs", {
                  imgLabs: `<img src="/img/ef-labs.png" style="height: 24px;vertical-align: bottom;" alt="${i18n.t(
                    "enhanced-formatting.enabled-modal.labs-button"
                  )}" />`
                })
              )}
            </StyledP>
          </div>
        ),
        buttons: [
          {
            label: i18n.t("onboarding.got-it"),
            click: function(e) {
              Fraction.Helpers.removeModal();
            }
          }
        ],
        width: 400
      },
      $("#ehanced-formatting-button")
    );
  }
};

module.exports = {
  metadata: () => {
    return {
      id: "enhanced-formatting",
      name: i18n.t("enhanced-formatting.enhanced-formatting"),
      description: i18n.t("enhanced-formatting.description"),
      lab: "graduate",
      type: "extension"
    };
  }
};
